<template>
  <section class="mt-5">
    <h2>お問い合わせ</h2>
    <!-- <script>
          if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
            $(function() {
              $('.sp-tel').each(function() {
                var str = $(this).html();
                if ($(this).children().is('img')) {
                  $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
                } else {
                  $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
                }
              });
            });
          }
        </script> -->
    <div>
      <h3>フォームによるお問い合わせ</h3>
      <div class="form-navi my-5">
        <ul class="d-flex">
          <li class="here">入力</li>
          <li>内容確認</li>
          <li>送信完了</li>
        </ul>
      </div>
      <div class="form-content">
        <p>以下の必要な項目をご入力の上、確認画面へ進むを押してください。</p>
        <div class="form-member my-5">
          <div class="inner">
            <form id="frmForm">
              <!-- 動的生成 -->
              <dl>
                <dt>お問い合わせ種類<span class="rqr">必須</span></dt>
                <dd>
                  <select
                    :disabled="isLock"
                    v-model="selContact"
                    ref="selContact"
                    class="px-3"
                  >
                    <option
                      v-for="item in this.dicContact"
                      :key="item.Key"
                      :value="item.Value"
                    >
                      {{ item.Value }}
                    </option>
                  </select>
                </dd>
                <dt>お問い合わせ内容<span class="rqr">必須</span></dt>
                <dd>
                  <textarea
                    v-model="contact"
                    ref="contact"
                    id="txtContact"
                    type="text"
                    maxlength="1600"
                    class="fa-01 w-100"
                    style="ime-mode: active"
                  ></textarea>
                </dd>
                <dt>氏名<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    v-model="name1"
                    ref="name1"
                    maxlength="20"
                    type="text"
                    class="input-name mr-3"
                    placeholder="(例)真奈"
                    style="ime-mode: active"
                  />
                  <input
                    v-model="name2"
                    ref="name2"
                    maxlength="20"
                    type="text"
                    class="input-name"
                    placeholder="(例)美須子"
                    style="ime-mode: active"
                  />
                </dd>
                <dt>氏名（フリガナ）<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    v-model="nameKana1"
                    ref="nameKana1"
                    maxlength="20"
                    type="text"
                    class="input-name mr-3"
                    placeholder="(例)マナ"
                    style="ime-mode: active"
                  />
                  <input
                    v-model="nameKana2"
                    ref="nameKana2"
                    maxlength="20"
                    type="text"
                    class="input-name"
                    placeholder="(例)ビスコ"
                    style="ime-mode: active"
                  /><br />
                  <p>カタカナで入力してください。</p>
                </dd>
                <dt>性別</dt>
                <dd>
                  <input
                    v-model="sex"
                    value="女性"
                    id="rdoSexW"
                    name="sex"
                    type="radio"
                    class="radio-01"
                  />
                  <label for="rdoSexW" class="mr-3">女性</label>
                  <input
                    v-model="sex"
                    value="男性"
                    id="rdoSexM"
                    name="sex"
                    type="radio"
                    class="radio-01 ml-2e"
                  />
                  <label for="rdoSexM">男性</label>
                </dd>
                <dt>年齢</dt>
                <dd>
                  <select id="selAge" v-model="age" class="px-3">
                    <option
                      v-for="item in this.dicAge"
                      :key="item.Key"
                      :value="item.Value"
                    >
                      {{ item.Value }}
                    </option>
                  </select>
                </dd>
                <dt>住所</dt>
                <dd>
                  <select v-model="area" id="selArea" class="px-3">
                    <option
                      v-for="item in this.dicArea"
                      :key="item.Key"
                      :value="item.Value"
                    >
                      {{ item.Value }}
                    </option>
                  </select>
                </dd>
                <dt>当社からの返信方法<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    v-model="reply"
                    ref="reply"
                    value="メール"
                    name="reply"
                    type="radio"
                    class="radio-01"
                  />
                  <label for="rdoMail" class="mr-3">メール</label>
                  <input
                    v-model="reply"
                    value="電話"
                    name="reply"
                    type="radio"
                    class="radio-01 ml-2e"
                  />
                  <label for="rdoTel" class="mr-3">電話</label>
                  <input
                    v-model="reply"
                    value="FAX"
                    name="reply"
                    type="radio"
                    class="radio-01 ml-2e"
                  />
                  <label for="rdoFax">FAX</label>
                </dd>
                <dt>メールアドレス<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    v-model="txtMail"
                    ref="txtMail"
                    id="txtMail"
                    type="email"
                    class="input-w60"
                    style="ime-mode: disabled"
                  />
                </dd>
                <dt>
                  電話番号（携帯可）<span
                    id="spnTel"
                    class="rqr"
                    style="visibility: hidden"
                    >必須</span
                  >
                </dt>
                <dd>
                  <input
                    v-model="txtTel"
                    ref="txtTel"
                    id="txtTel"
                    maxlength="11"
                    type="text"
                    inputmode="numeric"
                    class="input-w30"
                    placeholder="(例)9999999999"
                    style="ime-mode: disabled"
                  />
                  <br />
                  <p>ハイフン(-)は除いてください。</p>
                </dd>
                <dt>
                  FAX番号<span
                    id="spnFax"
                    class="rqr"
                    style="visibility: hidden"
                    >必須</span
                  >
                </dt>
                <dd>
                  <input
                    v-model="txtFax"
                    ref="txtFax"
                    id="txtFax"
                    maxlength="10"
                    type="text"
                    inputmode="numeric"
                    class="input-w30"
                    placeholder="(例)0888888888"
                    style="ime-mode: disabled"
                  />
                  <br />
                  <p>ハイフン(-)は除いてください。</p>
                </dd>
                <dt>当社からの連絡可能日</dt>
                <dd>
                  <select v-model="selDays" class="px-3">
                    <option value="">指定なし</option>
                    <option v-for="item in dateList" :key="item" :value="item">
                      {{ item }}
                    </option>
                  </select>
                </dd>
                <dt>当社からの連絡可能時間</dt>
                <dd>
                  <select v-model="selTimes" class="px-3">
                    <option
                      v-for="item in this.dicTimes"
                      :key="item.Key"
                      :value="item.Value"
                    >
                      {{ item.Value }}
                    </option>
                  </select>
                </dd>
                <dt>会員登録有無<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    v-model="isMember"
                    ref="isMember"
                    value="1"
                    id="rdoMember"
                    name="Member"
                    type="radio"
                    class="radio-01"
                  />
                  <label for="rdoMember" class="mr-5">会員</label>
                  <span class="fs-08 mr-3">会員番号:</span>
                  <input
                    v-model="txtMemberNo"
                    type="text"
                    inputmode="numeric"
                    class="input-name"
                    style="ime-mode: disabled"
                  />
                  <br />
                  <input
                    v-model="isMember"
                    value="0"
                    id="rdoNonMember"
                    name="Member"
                    type="radio"
                    class="radio-01"
                  />
                  <label for="rdoNonMember">未会員</label>
                </dd>
              </dl>
              <dl
                id="WantMgr"
                v-show="selContact == '入会について'"
                style="margin-bottom: 0; border-bottom: 0"
              >
                <dt>マネージャー（世話役の方）のご紹介</dt>
                <dd>
                  <input
                    v-model="chkWantMgr"
                    type="checkbox"
                    class="check-01"
                  />
                  <label for="chkWantMgr">希望する</label>
                </dd>
              </dl>
              <dl
                id="ForJoin"
                v-show="chkWantMgr"
                style="margin-bottom: 0; border-bottom: 0"
              >
                <dt style="width: 100%; float: none; background: #fff">
                  ※マネージャー（世話役の方）を紹介いたしますので、ご希望をお選びください。
                </dt>
                <dt>年齢<span class="rqr">必須</span></dt>
                <dd>
                  <select v-model="selSpoAge" ref="selSpoAge" class="px-3">
                    <option
                      v-for="item in dicSpoAge"
                      :key="item.Key"
                      :value="item.Key"
                    >
                      {{ item.Value }}
                    </option>
                  </select>
                </dd>
                <dt>性別<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    v-model="spoSex"
                    value="女性"
                    id="rdoSpoSexW"
                    name="SpoSex"
                    type="radio"
                    class="radio-01"
                  />
                  <label for="rdoSpoSexW">女性</label>
                  <input
                    v-model="spoSex"
                    ref="spoSex"
                    value="男性"
                    id="rdoSpoSexM"
                    name="SpoSex"
                    type="radio"
                    class="radio-01 ml-2e"
                  />
                  <label for="rdoSpoSexM">男性</label>
                  <input
                    v-model="spoSex"
                    value="どちらでも"
                    id="rdoSpoSex0"
                    name="SpoSex"
                    type="radio"
                    class="radio-01 ml-2e"
                  />
                  <label for="rdoSpoSex0">どちらでも</label>
                </dd>
                <dt>居住地域<span class="rqr">必須</span></dt>
                <dd>
                  <input
                    v-model="spoArea"
                    ref="spoArea"
                    value="近郊エリア"
                    id="rdoAreaN"
                    name="Area"
                    type="radio"
                    class="radio-01"
                  />
                  <label for="rdoAreaN">近郊エリア</label>
                  <input
                    v-model="spoArea"
                    value="遠方エリア"
                    id="rdoAreaF"
                    name="Area"
                    type="radio"
                    class="radio-01 ml-2e"
                  />
                  <label for="rdoAreaF">遠方エリア</label>
                  <input
                    v-model="spoArea"
                    value="どこでも"
                    id="rdoArea0"
                    name="Area"
                    type="radio"
                    class="radio-01 ml-2e"
                  />
                  <label for="rdoArea0">どこでも</label>
                </dd>
              </dl>
              <dl>
                <dt>その他ご要望</dt>
                <dd>
                  <textarea
                    v-model="txtAny"
                    type="text"
                    class="fa-01 w-100"
                    style="ime-mode: active"
                  ></textarea>
                </dd>
              </dl>
              <div class="box-p-20 text-center mt-5">
                <button
                  v-on:click="PutData"
                  id="btnConfirm"
                  type="button"
                  class="confirm-01 clear"
                >
                  確認画面へ進む
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-5">
      <h3>お電話によるお問い合わせ</h3>
      <div class="py-5 d-flex flex-wrap justify-content-around">
        <div class="text-center py-5">
          <p class="title border-bottom">ルール プログラム 各種セミナー</p>
          <p class="number">0120-268-510</p>
          <p class="time">受付時間 9:00～17:00 土・日・祝日休</p>
        </div>
        <div class="text-center py-5">
          <p class="title border-bottom">商品相談窓口</p>
          <p class="number">0120-649-510</p>
          <p class="time">受付時間 9:00～17:00 土・日・祝日休</p>
        </div>
        <div class="text-center py-5">
          <p class="title border-bottom">注文専用</p>
          <p class="number">0800-222-0510</p>
          <p class="time">受付時間 9：00～16：00 土・日・祝日休</p>
        </div>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import moment from "moment";
import Message from "@/modules/Message";
import Utl from "@/modules/Utl";
import Request from "@/modules/Request";
let request = new Request();
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
export default {
  data() {
    return {
      selContact: "A",
      isLock: false,
      contact: "",
      name1: "",
      name2: "",
      nameKana1: "",
      nameKana2: "",
      sex: "選択無し",
      age: "A",
      area: "－",
      reply: "",
      txtMail: "",
      txtTel: "",
      txtFax: "",
      selDays: "",
      selTimes: "A",
      isMember: "",
      txtMemberNo: "",
      chkWantMgr: "",
      selSpoAge: "A",
      spoSex: "",
      spoArea: "",
      txtAny: "",
      dateList: [],
      dicContact: [],
      dicAge: [],
      dicArea: [],
      dicTimes: [],
      dicSpoAge: [],
      dicRefs: {},
      uux: "",
    };
  },
  mounted() {
    this.dicRefs = {
      arg1: this.$refs.selContact,
      arg2: this.$refs.contact,
      arg3: this.$refs.name1,
      arg4: this.$refs.name2,
      arg5: this.$refs.nameKana1,
      arg6: this.$refs.nameKana2,
      arg10: this.$refs.reply,
      arg11: this.$refs.txtMail,
      arg12: this.$refs.txtTel,
      arg13: this.$refs.txtFax,
      arg16: this.$refs.isMember,
      arg18: this.$refs.selSpoAge,
      arg19: this.$refs.spoSex,
      arg20: this.$refs.spoArea,
    };
    this.dateList = this.setDate();
    this.getData();
    this.refCheck();
    window.scroll(0, 0);
  },
  methods: {
    setDate() {
      const today = new moment();
      let dateList = [];

      for (let i = 0; i < 7; i++) {
        let date = moment(today.format("yyyy-MM-DD"));
        dateList.push(date.add(i, "day").format("yyyy/MM/DD"));
      }
      return dateList;
    },
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getFormItems",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.dicContact = data.dicContact;
          this.dicAge = data.dicAge;
          this.dicArea = data.dicArea;
          this.dicTimes = data.dicTimes;
          this.dicSpoAge = data.dicSpoAge;
        });

      requestParams = request.createParams(
        "webMdlNewJoin",
        "getSession",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          if (auth.getNoLoginUid() == "") {
            this.uux = data.uux;
            auth.setNoLoginUid(this.uux);
          }
        });
    },
    PutData() {
      if (!this.chkSelContact()) return;
      if (!this.chkContact()) return;
      if (!this.chkName()) return;
      if (!this.chkKana()) return;
      if (!this.chkReply()) return;
      if (!this.chkMailAddress()) return;
      if (this.chkWantMgr) {
        if (!this.chkSpoAge()) return;
        if (!this.chkSpoSex()) return;
        if (!this.chkSpoArea()) return;
      }
      let params = [
        this.selContact,
        this.contact,
        this.name1,
        this.name2,
        this.nameKana1,
        this.nameKana2,
        this.sex,
        this.age,
        this.area,
        this.reply,
        this.txtMail,
        this.txtTel,
        this.txtFax,
        this.selDays,
        this.selTimes,
        this.isMember,
        this.txtMemberNo,
        this.selSpoAge,
        this.spoSex,
        this.spoArea,
        this.txtAny,
        this.chkWantMgr,
        true,
        this.uux,
      ];
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "putContact",
        params,
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          let focusEl = null;
          if (data.status == "bad") {
            Message.error().fire({
              title: data.msg,
              didClose: () => {
                focusEl = this.dicRefs[data.arg];
                if (focusEl) {
                  focusEl.focus();
                }
              },
            });
          } else {
            this.$router.push({
              path: "/contact/confirm",
              query: {
                ref: this.$route.query.ref,
              },
            });
          }
        });
    },
    refCheck() {
      let requestParams;
      switch (this.$route.query.ref) {
        case "admission":
          this.selContact = "入会について";
          this.isLock = true;
          break;
        case "Confirm":
          requestParams = request.createParams(
            "webMdlNewJoin",
            "getData",
            [],
            true
          );
          request
            .create()
            .post("", requestParams)
            .then((data) => {
              this.selContact = data.SelContact;
              this.isLock = this.selContact == "入会について" ? true : false;
              this.contact = data.Contact;
              this.name1 = data.Name1;
              this.name2 = data.Name2;
              this.nameKana1 = data.NameKana1;
              this.nameKana2 = data.NameKana2;
              this.sex = data.Sex;
              this.age = data.Age;
              this.area = data.Part1OfAddress;
              this.reply = data.Reply;
              this.txtMail = data.MailAddress;
              this.txtTel = data.TelNo.replace(/-/g, "");
              this.txtFax = data.FaxNo.replace(/-/g, "");
              this.selDays = data.ContactDay;
              this.selTimes = data.ContactTime;
              this.isMember = data.IsMember;
              this.txtMemberNo = data.MemberNo;
              this.WantMgr = data.SpoWant;
              this.chkWantMgr = data.SpoWant == "希望する" ? true : false;
              this.selSpoAge = data.SpoAge;
              this.spoSex = data.SpoSex;
              this.spoArea = data.SpoArea;
              this.txtAny = data.Demand;
            });
          break;
      }
    },
    chkSelContact() {
      //admission以外から来た際に必要になる
      if (this.selContact < "B") {
        Message.error().fire({
          title: "お問い合わせ種類を選択して下さい",
          didClose: () => {
            this.$refs.selContact.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkContact() {
      let mes = Utl.chkMustInput("お問い合わせ内容", this.contact);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.contact.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkName() {
      let mes = Utl.chkMustInput("氏名の姓", this.name1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.name1.focus();
          },
        });
        return false;
      }
      mes = Utl.chkCanUseChars("氏名の姓", this.name1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.name1.focus();
          },
        });
        return false;
      } else {
        let mes = Utl.chkMustInput("氏名の名", this.name2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.name2.focus();
            },
          });
          return false;
        }
        mes = Utl.chkCanUseChars("氏名の名", this.name2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.name2.focus();
            },
          });
          return false;
        }
      }
      return true;
    },
    chkKana() {
      let mes = Utl.chkMustInput("氏名(フリガナ)の姓", this.nameKana1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.nameKana1.focus();
          },
        });
        return false;
      }
      mes = Utl.chkCanUseKana("氏名(フリガナ)の姓", this.nameKana1);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.nameKana1.focus();
          },
        });
        return false;
      } else {
        mes = Utl.chkMustInput("氏名(フリガナ)の名", this.nameKana2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.nameKana2.focus();
            },
          });
          return false;
        }
        mes = Utl.chkCanUseKana("氏名(フリガナ)の名", this.nameKana2);
        if (mes.length != 0) {
          Message.error().fire({
            title: mes,
            didClose: () => {
              this.$refs.nameKana2.focus();
            },
          });
          return false;
        }
      }
      return true;
    },
    chkReply() {
      if (this.reply == "") {
        Message.error().fire({
          title: "当社からの返信方法を選択して下さい。",
          didClose: () => {
            this.$refs.reply.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkMailAddress() {
      let mes = Utl.chkMustInput("メールアドレス", this.txtMail);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.txtMail.focus();
          },
        });
        return false;
      }
      mes = Utl.chkMailAddress("メールアドレス", this.txtMail);
      if (mes.length != 0) {
        Message.error().fire({
          title: mes,
          didClose: () => {
            this.$refs.txtMail.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkSpoAge() {
      if (this.selSpoAge == "A") {
        Message.error().fire({
          title: "世話役の方の年齢を選択して下さい。",
          didClose: () => {
            this.$refs.selSpoAge.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkSpoSex() {
      if (this.spoSex.length == 0) {
        Message.error().fire({
          title: "世話役の方の性別を選択して下さい。",
          didClose: () => {
            this.$refs.spoSex.focus();
          },
        });
        return false;
      }
      return true;
    },
    chkSpoArea() {
      if (this.spoArea.length == 0) {
        Message.error().fire({
          title: "世話役の方の居住地域を選択して下さい。",
          didClose: () => {
            this.$refs.spoArea.focus();
          },
        });
        return false;
      }
      return true;
    },
  },
};
</script>
